import toast from "react-hot-toast";
import { ConfirmDeleteModal } from "../shared/modals/ConfirmDeleteModal";
import axios from "../utils/axiosConfig";



/* V2 Services */



export const deleteEpic = async (epic_id: string) => {
    const confirmationDelete = await ConfirmDeleteModal("Epic");
    if (!confirmationDelete) return;
      try {
        await toast.promise(axios.delete(`/roadmap/${epic_id}`), {
            loading: 'Deleting...',
            success: 'Deleted successfully!',
            error: 'Failed to delete.'
          });
        return true;
      } catch (error) {
        console.error("Error deleting epic:", error);
        throw error;
      }
};


export const useEpicService = () => {
  
  return {
    deleteEpic
  }
}